import { AfterViewInit, Directive, ElementRef, NgZone, OnDestroy, Renderer2 } from "@angular/core";
import { AgsAuthService } from "@ags/core";

@Directive({
  standalone: false,
  selector: "ags-header[agsUserMenuFix]",
})
export class HeaderUserMenuFixDirective implements AfterViewInit, OnDestroy {
  private observer: MutationObserver | null = null;
  private debounceTimer: any = null;
  private userMenuFixed = false;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private ngZone: NgZone,
    private authService: AgsAuthService
  ) { }

  ngAfterViewInit() {
    this.ngZone.runOutsideAngular(() => {
      this.observer = new MutationObserver(() => {
        if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
        }

        this.debounceTimer = setTimeout(() => this.fixUserMenu(), 50);
      });

      this.observer.observe(this.el.nativeElement, {
        childList: true,
        subtree: true,
      });
    });

    setTimeout(() => this.fixUserMenu(), 100);
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  }

  private fixUserMenu() {
    if (this.userMenuFixed) {
      return;
    }

    const userMenu = this.el.nativeElement.querySelector("#ags-user-menu");
    if (!userMenu) {
      return;
    }

    const dropdownMenu = userMenu.querySelector(".dropdown-menu");
    if (!dropdownMenu) {
      return;
    }

    const hasContent = dropdownMenu.querySelector(".dropdown-item");
    if (hasContent) {
      return;
    }

    this.authService.getAccount().then((account) => {
      if (!account) {
        return;
      }

      this.userMenuFixed = true;

      const nameItem = this.renderer.createElement("span");
      this.renderer.addClass(nameItem, "dropdown-item");
      this.renderer.addClass(nameItem, "user-menu-name");
      this.renderer.setAttribute(nameItem, "role", "menuitem");
      nameItem.textContent = account.name || "";
      this.renderer.appendChild(dropdownMenu, nameItem);

      const emailItem = this.renderer.createElement("span");
      this.renderer.addClass(emailItem, "dropdown-item");
      this.renderer.addClass(emailItem, "user-menu-email");
      this.renderer.setAttribute(emailItem, "role", "menuitem");
      emailItem.textContent = account.username || "";
      this.renderer.appendChild(dropdownMenu, emailItem);

      const divider1 = this.renderer.createElement("div");
      this.renderer.addClass(divider1, "dropdown-divider");
      this.renderer.setAttribute(divider1, "role", "separator");
      this.renderer.appendChild(dropdownMenu, divider1);

      const divider2 = this.renderer.createElement("div");
      this.renderer.addClass(divider2, "dropdown-divider");
      this.renderer.setAttribute(divider2, "role", "separator");
      this.renderer.appendChild(dropdownMenu, divider2);

      const anotherAccountBtn = this.renderer.createElement("button");
      this.renderer.addClass(anotherAccountBtn, "dropdown-item");
      this.renderer.setAttribute(anotherAccountBtn, "type", "button");
      this.renderer.setAttribute(anotherAccountBtn, "role", "menuitem");
      anotherAccountBtn.textContent = "Use another account";
      this.renderer.listen(anotherAccountBtn, "click", () => {
        this.authService.loginRedirect();
      });
      this.renderer.appendChild(dropdownMenu, anotherAccountBtn);

      const signOutBtn = this.renderer.createElement("button");
      this.renderer.addClass(signOutBtn, "dropdown-item");
      this.renderer.setAttribute(signOutBtn, "type", "button");
      this.renderer.setAttribute(signOutBtn, "role", "menuitem");
      signOutBtn.textContent = "Sign out";
      this.renderer.listen(signOutBtn, "click", () => {
        this.authService.logout();
      });
      this.renderer.appendChild(dropdownMenu, signOutBtn);
    });
  }
}
